
export const ApiUrl = 'https://minasidor.verbal.se/api';
